import React from "react";
import { Monitor as MonitorIcon } from "lucide-react";

function EmptyState({ icon: Icon = MonitorIcon, title, description, action }) {
  return (
    <div className="empty-state" role="status">
      <span className="empty-state-badge" aria-hidden="true">
        <Icon className="empty-state-icon" size={32} strokeWidth={1.5} />
      </span>
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}

export default EmptyState;
